var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSagittarius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#7945D3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0608 4.89638C15.028 4.86361 14.9806 4.85118 14.9354 4.86248L10.6823 6.0026C10.6371 6.01503 10.602 6.05005 10.5907 6.09412C10.5783 6.13932 10.5907 6.18678 10.6246 6.21954L11.8066 7.40147L6.95459 12.2693L5.75346 11.0681C5.55007 10.8647 5.22125 10.8647 5.01786 11.0681C4.81447 11.2715 4.81447 11.6003 5.01786 11.8037L6.22012 13.006L5.00995 14.2207C4.80769 14.4241 4.80769 14.7529 5.01108 14.9563C5.11278 15.058 5.24498 15.1077 5.37831 15.1077C5.51165 15.1077 5.64498 15.0568 5.74668 14.9551L6.95571 13.7416L8.16927 14.9551C8.27097 15.0568 8.4043 15.1077 8.53651 15.1077C8.66871 15.1077 8.80317 15.0568 8.90374 14.9551C9.10713 14.7517 9.10713 14.4229 8.90374 14.2195L7.68905 13.0049L12.541 8.13705L13.7376 9.33367C13.7625 9.35853 13.7953 9.37209 13.8292 9.37209C13.8405 9.37209 13.8518 9.37095 13.8631 9.36757C13.9083 9.35514 13.9433 9.32011 13.9546 9.27604L15.0947 5.02293C15.1071 4.97773 15.0947 4.93028 15.0608 4.89751V4.89638Z",
    fill: "white",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSagittarius);
export default __webpack_public_path__ + "static/media/sagittarius.64c60a5624e9c36f41e0c438348e32f2.svg";
export { ForwardRef as ReactComponent };